// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35XfE","right":"styles_right__3ZPzt"};